/** アプリ共通トースト（{@link NotifyToaster} / `useNotify`）の Toaster ID。 */
export const NOTIFY_TOASTER_ID = "im-notify";
